import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "./api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(undefined); // undefined = checking, null = anon
    const [loading, setLoading] = useState(true);

    const refresh = useCallback(async () => {
        try {
            const { data } = await api.get("/auth/me");
            setUser(data);
            return data;
        } catch {
            setUser(null);
            return null;
        }
    }, []);

    useEffect(() => {
        (async () => {
            await refresh();
            setLoading(false);
        })();
    }, [refresh]);

    const login = useCallback(async (email, password) => {
        const { data } = await api.post("/auth/login", { email, password });
        setUser(data);
        return data;
    }, []);

    const logout = useCallback(async () => {
        try {
            await api.post("/auth/logout");
        } catch {
            // ignore
        }
        setUser(null);
    }, []);

    return (
        <AuthContext.Provider value={{ user, setUser, loading, login, logout, refresh }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);

export const applyTenantTheme = (tenant) => {
    const root = document.documentElement;
    if (tenant && tenant.brand) {
        root.style.setProperty("--tenant-primary", tenant.brand.primary || "#F59E0B");
        root.style.setProperty("--tenant-primary-foreground", tenant.brand.primary_foreground || "#000000");
        root.style.setProperty("--tenant-secondary", tenant.brand.secondary || "#A1A1AA");
    } else {
        root.style.setProperty("--tenant-primary", "#F59E0B");
        root.style.setProperty("--tenant-primary-foreground", "#000000");
        root.style.setProperty("--tenant-secondary", "#A1A1AA");
    }
};
